export default "__VITE_PUBLIC_ASSET__c488ec9c__"